import { useQuery } from '@tanstack/react-query';
import type { TGetMoodBoardsResponse } from 'api/resources/moodBoards';
import { getMoodBoards } from 'api/resources/moodBoards';
import { ECacheKeys } from 'cache/CacheKeys';

// `enabled` lets a caller that only needs the boards behind a feature flag —
// the dashboard's "Mood Boards to review" action item — skip the request
// entirely when the flag is off.
export const useGetMoodBoards = (token: string, enabled = true) => {
	return useQuery<TGetMoodBoardsResponse>({
		queryKey: [ECacheKeys.MoodBoards],
		queryFn: () => getMoodBoards(token),
		retry: 1,
		refetchOnWindowFocus: false,
		enabled,
	});
};
